// packages block
import debounce from "lodash/debounce";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useCallback, useEffect, useState } from "react";
import { CircularProgress, Typography } from "@material-ui/core";
// common block
import "./style.css";
import { TableHeader } from "./components";
import { ManagementTable } from "../../../components/managementTable";
import { StudentConfirmationDeleteDialog } from "../../../components/dialogs/studentConfirmationDeleteDialog";
import {
  PreAddDialog,
  AddStudentDialog,
  FileUploader,
  AddInvoiceDialog,
  OnSuccessDialog,
} from "../../../components/dialogs";
// constants, theme, utils and api block
import { getAllSchools } from "../../../api/schools";
import { setAlert } from "../../../redux/reducers/alert";
import {
  addMultipleStudents,
  deleteStudent,
  getAllStudents,
  searchStudents,
  deleteStudents,
  updateMultipleStudents,
} from "../../../api/student";
import { capitalizeFirstLetter } from "../../../util/Date";
import { PreUpdateDialog } from "../../../components/dialogs/preUpdateDialog";
import bulkStudent from "../../../assets/csv/bulk-student.csv";
import { setLoadingForAllSyncButtons } from "../../../redux/reducers/allSyncButtonsLoader";

export const StudentManagement = () => {
  const [students, setStudents] = useState([]);
  const [payeeType, setPayeeType] = useState("STUDENT");
  const [isPreAddDialogVisible, setIsPreAddDialogVisible] = useState(false);
  const [isPreUpdateDialogVisible, setIsPreUpdateDialogVisible] =
    useState(false);
  const [isAddStudentDialogVisible, setIsAddStudentDialogVisible] =
    useState(false);
  const [isEditStudentDialogVisible, setIsEditStudentDialogVisible] =
    useState(false);
  const [isAddInvoiceDialogVisible, setIsAddInvoiceDialogVisible] =
    useState(false);
  const [isOnSuccessDialogVisible, setIsOnSuccessDialogVisible] =
    useState(false);
  const [isOnStudentSuccessDialogVisible, setIsOnStudentSuccessDialogVisible] =
    useState(false);

  const [
    isOnConfirmationStudentDialogVisible,
    setIsOnConfirmationStudentDialogVisible,
  ] = useState(false);
  const [
    isConfirmationDeleteDialogVisible,
    setIsConfirmationDeleteDialogVisible,
  ] = useState(false);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(null);
  const [isEditedItem, setIsEditedItem] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [startEntry, setStartEntry] = useState(1);
  const [endEntry, setEndEntry] = useState(10);
  const [rowSelectedId, setRowSelectedId] = useState(null);

  const [isFileUploaderVisible, setIsFileUploaderVisible] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [studentId, setStudentId] = useState(null);
  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];
  const { token, schoolId, role, id, user } = useSelector(
    (state) => state.user
  );
  const history = useHistory();
  const { t } = useTranslation();
  let limit = 10;

  const tablePayeeType = capitalizeFirstLetter(payeeType?.toLowerCase());
  const payeeTypeForManagers =
    role === "superadmin" ? "" : `(${tablePayeeType})`;

  const STUDENT_MANAGMENT_COLUMNS = [
    //{ id: "id", numeric: false, disablePadding: true, label: "ID" },
    {
      id: "studentRegNo",
      numeric: false,
      disablePadding: true,
      label: `${t("text_payee_id")} ${payeeTypeForManagers}`,
    },
    // {
    //   id: "payeeType",
    //   numeric: false,
    //   disablePadding: true,
    //   label: t("text_payee_type"),
    // },
    { id: "name", numeric: false, disablePadding: true, label: t("text_name") },
    {
      id: "grade",
      numeric: false,
      disablePadding: true,
      label: t("text_grade"),
    },
    {
      id: "contact",
      numeric: false,
      disablePadding: true,
      label: t("text_contact"),
    },
    { id: "actions", numeric: false, disablePadding: true, label: "" },
  ];

  const openPreAddDialog = () => setIsPreAddDialogVisible(true);
  const closePreAddDialog = () => setIsPreAddDialogVisible(false);
  const openPreUpdateDialog = (event) => {
    event.stopPropagation();
    setIsPreUpdateDialogVisible(true);
  };
  const closePreUpdateDialog = () => setIsPreUpdateDialogVisible(false);

  const openAddSchoolDialog = () => {
    closePreAddDialog();
    setIsAddStudentDialogVisible(true);
  };

  const closeAddStudentDialog = () => {
    setIsAddStudentDialogVisible(false);
    setIsPreAddDialogVisible(true);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };
  const closeEditStudentDialog = () => {
    setIsEditStudentDialogVisible(false);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };

  const closeAddInvoiceDialog = () => {
    setIsAddInvoiceDialogVisible(false);
    setTimeout(() => {
      setIsEditedItem(null);
    }, 500);
  };

  const dispatch = useDispatch();

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const goHome = () => {
    window.location.reload();
  };

  const viewDetailWithGenrateDialogue = async (id) => {
    history.push({
      pathname: `/students/student-detail/${id}`,
      state: {
        openGenerateIvoiceDialog: true,
      },
    });
  };

  const handlePage = (pageNumber) => setPage(pageNumber);

  const handleSelection = (ids) => {
    setSelectedIds(ids);
  };

  const fetchStudents = async () => {
    try {
      const response = await getAllStudents(page, token, limit);
      setStartEntry(page === 0 ? 1 : page * limit + 1);
      setEndEntry(
        (page + 1) * limit > response?.students.count
          ? response.students.count
          : (page + 1) * limit
      );
      if (response && response.status) {
        //alert(response.students.rows);
        setStudents(response?.students.rows);
        setTotalCount(response?.students.count);
      } else {
        showErrorAlert(response?.message);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      showErrorAlert(
        e || e.message || t("text_something_went_wrong_try_again_later")
      );
    }
  };

  const successCallback = async (student) => {
    setStudents([student, ...students]);
    closeAddStudentDialog();
    setIsEditedItem(null);
    setIsOnStudentSuccessDialogVisible(true);
  };

  const successInvoiceCallback = async () => {
    const id = isEditedItem.id;
    closeAddInvoiceDialog();
    // setIsEditedItem(null);
    viewItem(id);
  };
  const editStudent = (item) => {
    setIsEditedItem(item);
    setIsEditStudentDialogVisible(true);
  };
  const editInvoice = (item) => {
    setIsEditedItem(item);
    setIsAddInvoiceDialogVisible(true);
  };

  const editSuccessCallback = async (item) => {
    setStudentId(item.id);
    const updatedStudents = students.map((studentItem) => {
      if (studentItem.id === item.id) {
        return item;
      } else return studentItem;
    });
    closeAddStudentDialog();
    setStudents(updatedStudents);
    setIsOnSuccessDialogVisible(true);
  };

  const deleteItem = async (id) => {
    try {
      await deleteStudent(rowSelectedId, token);
      showSuccessAlert(t("text_student_deleted_successfully"));
      local.push({
        message: "student deleted successfully",
        date: new Date().getTime(),
        newNotification: true,
      });
      localStorage.setItem("notify", JSON.stringify(local));
      deleteCallback(id);
      setIsConfirmationDeleteDialogVisible(false);
    } catch (err) {
      showErrorAlert(
        err.message || t("text_error_in_deleting_student_please_try_again")
      );
    }
  };

  const deleteCallback = async (id) => {
    const updatedStudents = students.filter((item) => item.id !== id);
    setStudents(updatedStudents);
  };

  const multipleDeleteCallBack = () => {
    const updatedStudents = students.filter(
      (item) => selectedIds.indexOf(item.id) < 0
    );
    setStudents(updatedStudents);
    setSelectedIds([]);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await deleteStudents(selectedIds, token);
      if (response && response.status) {
        multipleDeleteCallBack();
        showSuccessAlert(t("text_student_deleted_successfully"));
        local.push({
          message: "Students deleted successfully",
          date: new Date().getTime(),
        });
        localStorage.setItem("notify", JSON.stringify(local));
        setIsOnConfirmationStudentDialogVisible(false);
      } else {
        showErrorAlert(
          response.message ||
            t("text_error_in_deleting_student_please_try_again")
        );
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      showErrorAlert(
        err.message || t("text_error_in_deleting_student_please_try_again")
      );
    }
  };

  const handleOpenDeleteDialog = () => {
    setIsOnConfirmationStudentDialogVisible(true);
  };

  const handleCencel = () => {
    setIsFileUploaderVisible(false);
    setIsOnConfirmationStudentDialogVisible(false);
  };
  const handleDeleteDialogueCancel = () => {
    setIsConfirmationDeleteDialogVisible(false);
  };

  const handleFileUpload = async (file) => {
    closePreAddDialog();
    setIsFileUploaderVisible(true);

    try {
      setLoading(true);
      const response = await addMultipleStudents(file, schoolId, token);
      if (response.length === 0) {
        showErrorAlert(t("text_no_unique_student_found"));
      } else {
        if (response?.data) setStudents([...response, ...students]);
        showSuccessAlert(t("text_students_added_successfully"));
        local.push({
          message: t("text_students_added_successfully"),
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
        setLoading(false);
        history.push("/students");
      }
      setIsFileUploaderVisible(false);
      setLoading(false);
    } catch (err) {
      showErrorAlert( t("text_error_in_multiple_file_uploading"));
      setIsFileUploaderVisible(false);
      setLoading(false);
    }
  };

  const handleupdateMultipleStudents = async (file) => {
    setIsFileUploaderVisible(true);

    try {
      setLoading(true);
      dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: true }));
      const response = await updateMultipleStudents(file, schoolId, token);
      const { status, message } = response;
      if (!status) {
        showErrorAlert(message || "Something went wrong");
      } else {
        showSuccessAlert(message || "Students updated successfully");
        local.push({
          message: "Students updated successfully",
          date: new Date().getTime(),
          newNotification: true,
        });
        localStorage.setItem("notify", JSON.stringify(local));
        setLoading(false);
        // window.location.reload();
        // history.push("/students")
      }
      setIsFileUploaderVisible(false);
      dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: false }));
      setLoading(false);
    } catch (err) {
      dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: false }));
      showErrorAlert(err.message || t("text_error_in_multiple_file_uploading"));
      setIsFileUploaderVisible(false);
      setLoading(false);
    }
  };

  const getLatestCreateStudentId = (id) => {
    setStudentId(id);
  };

  const fetchSchools = async () => {
    try {
      const payload = {
        role,
        id,
        schoolId,
      };
      const response = await getAllSchools(payload, token);

      if (response?.status) {
        setPayeeType(response?.schools[0].payeeType);
      }
    } catch (e) {}
  };

  useEffect(() => {
    fetchSchools();
  }, []);

  useEffect(() => {
    if (searchString === "") {
      setLoading(true);
      fetchStudents();
    } else {
      setLoading(true);
      (async () => {
        try {
          setStudents([]);
          const response = await searchStudents(searchString, token);
          if (response && response.status) {
            setTotalCount(response?.getStudent.count);
            setStudents(response?.getStudent.rows);
            if (
              response.getStudent.count === 0 ||
              response.getStudent.rows.length === 0
            ) {
              showErrorAlert(t("text_records_not_found"));
            }
          }
          setLoading(false);
        } catch (err) {
          showErrorAlert(err.message || t("text_error_in_searching_students"));
          setLoading(false);
        }
      })();
    }
  }, [searchString, page]);

  const debounceSearchString = useCallback(debounce(setSearchString, 400), []);

  const handleSearching = (value) => {
    setPage(0);
    setTotalCount(0);
    debounceSearchString(value);
  };

  const viewItem = async (id) => history.push(`/students/student-detail/${id}`);
  return (
    <div className="school-management-page">
      <Typography
        variant="h4"
        style={{ fontFamily: "Monsteric, sans-serif", marginBottom: 20 }}
      >
        {t("text_student_management")}
      </Typography>

      <div className="school-management-container">
        <TableHeader
          handleSearching={handleSearching}
          selectedIds={selectedIds}
          handleAdd={openPreAddDialog}
          handleUpdate={openPreUpdateDialog}
          handleOpenDeleteDialog={handleOpenDeleteDialog}
          handleupdateMultipleStudents={handleupdateMultipleStudents}
        />

        {loading ? (
          <div className={"school-loader"}>
            <CircularProgress size={20} style={{ color: "black" }} />
            {t("text_fetching_student_data")}
          </div>
        ) : (
          <ManagementTable
            handleSelection={handleSelection}
            pageNumber={page}
            handlePage={handlePage}
            totalCount={totalCount}
            tableFor="students"
            data={students}
            editItem={editStudent}
            editInvoice={editInvoice}
            deleteItem={deleteItem}
            columns={STUDENT_MANAGMENT_COLUMNS}
            viewItem={viewItem}
            startEntry={startEntry}
            endEntry={endEntry}
            isConfirmationDeleteDialogVisible={
              isConfirmationDeleteDialogVisible
            }
            setIsConfirmationDeleteDialogVisible={
              setIsConfirmationDeleteDialogVisible
            }
            setRowSelectedId={setRowSelectedId}
          />
        )}
      </div>

      <PreAddDialog
        title={t("text_add_student")}
        singleTitle={t("text_add_single_student")}
        multipleTitle={t("text_add_multiple_students")}
        handleClose={closePreAddDialog}
        open={isPreAddDialogVisible}
        addSchool={openAddSchoolDialog}
        addButtonTitle={t("text_add_student")}
        handleFileUpload={handleFileUpload}
        backbut={true}
      />
      <PreUpdateDialog
        title={t("text_update_students")}
        multipleTitle={"Update Multiple Students"}
        handleClose={closePreUpdateDialog}
        open={isPreUpdateDialogVisible}
        addSchool={openAddSchoolDialog}
        addButtonTitle={t("text_add_student")}
        handleFileUpload={handleupdateMultipleStudents}
        backbut={true}
        url={bulkStudent}
      />

      {isEditStudentDialogVisible && (
        <AddStudentDialog
          title={t("text_edit_student")}
          handleClose={closeEditStudentDialog}
          open={isEditStudentDialogVisible}
          successCallback={successCallback}
          isEditedItem={isEditedItem}
          editSuccessCallback={editSuccessCallback}
          showCircularProgressBar={true}
          getLatestCreateStudentId={getLatestCreateStudentId}
          payeeType={payeeType}
          edit={true}
          setEditPopup={setIsEditStudentDialogVisible}
        />
      )}
      {isAddStudentDialogVisible && (
        <AddStudentDialog
          title={t("text_add_student")}
          handleClose={closeAddStudentDialog}
          open={isAddStudentDialogVisible}
          successCallback={successCallback}
          isEditedItem={isEditedItem}
          editSuccessCallback={editSuccessCallback}
          showCircularProgressBar={true}
          getLatestCreateStudentId={getLatestCreateStudentId}
          payeeType={payeeType}
        />
      )}

      {isAddInvoiceDialogVisible && (
        <AddInvoiceDialog
          title={"Generate Invoice"}
          handleClose={closeAddInvoiceDialog}
          open={isAddInvoiceDialogVisible}
          successCallback={successInvoiceCallback}
          isGenratedItem={isEditedItem}
        />
      )}

      {isOnSuccessDialogVisible && (
        <OnSuccessDialog
          handleClose={closeAddInvoiceDialog}
          open={isOnSuccessDialogVisible}
          isEditedItem={studentId}
          goHome={goHome}
          viewDetailWithGenrateDialogue={viewDetailWithGenrateDialogue}
        />
      )}

      {isOnStudentSuccessDialogVisible && (
        <OnSuccessDialog
          handleClose={closeAddStudentDialog}
          open={isOnStudentSuccessDialogVisible}
          studentTitle={t("text_student_create")}
          goHome={goHome}
          isEditedItem={studentId}
          viewDetailWithGenrateDialogue={viewDetailWithGenrateDialogue}
        />
      )}
      {isOnConfirmationStudentDialogVisible && (
        <StudentConfirmationDeleteDialog
          open={isOnConfirmationStudentDialogVisible}
          close={handleCencel}
          loading={loading}
          handleDelete={handleDelete}
          title={t("text_student")}
        />
      )}
      {isConfirmationDeleteDialogVisible && (
        <StudentConfirmationDeleteDialog
          open={isConfirmationDeleteDialogVisible}
          close={handleDeleteDialogueCancel}
          loading={loading}
          handleDelete={deleteItem}
          title={t("text_student")}
        />
      )}

      <FileUploader open={isFileUploaderVisible} loading={loading} />
    </div>
  );
};
